const angular = require('angular')
const scheduleCtrl = require('./scheduleCtrl')

module.exports = angular.module('hxphone.schedule', ['hxphone.services'])
  .controller('scheduleCtrl', scheduleCtrl)



// WEBPACK FOOTER //
// ./src/js/schedule/module.js